import { convertToThousandsLabel } from '@vue/store/helpers';

export const activeFilters = state => {
  let searchParams = state.searchParams;
  const activeFilters = [];

  if(searchParams.min_asking_price){
    let minLabel = convertToThousandsLabel(searchParams.min_asking_price, state.searchType);
    let filterValue = `> ${minLabel}`;
    activeFilters.push({
      displayName: 'Asking Price',
      field: 'min_asking_price',
      text: filterValue,
      value: searchParams.min_asking_price
    });
  }

  if(searchParams.max_asking_price){
    let maxLabel = convertToThousandsLabel(searchParams.max_asking_price, state.searchType);
    let filterValue = `< ${maxLabel}`;
    activeFilters.push({
      displayName: 'Asking Price',
      field: 'max_asking_price',
      text: filterValue,
      value: searchParams.max_asking_price
    });
  }
  if(state.searchType !== 'for-sale'){

    if(searchParams.min_rent_amt){
      let minLabel = convertToThousandsLabel(searchParams.min_rent_amt, 'for-rent');
      let filterValue = `> ${minLabel}`;
      activeFilters.push({
        displayName: 'Rent Amount',
        field: 'min_rent_amt',
        text: filterValue,
        value: searchParams.min_rent_amt
      });
    }

    if(searchParams.max_rent_amt){
      let maxLabel = convertToThousandsLabel(searchParams.max_rent_amt, 'for-rent');
      let filterValue = `< ${maxLabel}`;
      activeFilters.push({
        displayName: 'Rent Amount',
        field: 'max_rent_amt',
        text: filterValue,
        value: searchParams.max_rent_amt
      });
    }

       
  }


  if(searchParams.min_beds){
    let minLabel = searchParams.min_beds;
    let filterValue = `> ${minLabel} Beds`;
    activeFilters.push({
      displayName: 'Beds',
      field: 'min_beds',
      text: filterValue,
      value: searchParams.min_beds
    });
  }

  if(searchParams.max_beds){
    let maxLabel = searchParams.max_beds;
    let filterValue = `< ${maxLabel} Beds`;
    activeFilters.push({
      displayName: 'Beds',
      field: 'max_beds',
      text: filterValue,
      value: searchParams.max_beds
    });
  }

  if(searchParams.min_baths){
    let minLabel = searchParams.min_baths;
    let filterValue = `> ${minLabel} Baths`;
    activeFilters.push({
      displayName: 'Min. Baths',
      field: 'min_baths',
      text: filterValue,
      value: searchParams.min_baths
    });
  }

  if(searchParams.max_baths){
    let maxLabel = searchParams.max_baths;
    let filterValue = `< ${maxLabel} Baths`;
    activeFilters.push({
      displayName: 'Max. Baths',
      field: 'max_baths',
      text: filterValue,
      value: searchParams.max_baths
    });
  }

  if(searchParams.min_year_built){
    let minLabel = searchParams.min_year_built;
    let filterValue = `Year Built >= ${minLabel}`;
    activeFilters.push({
      displayName: 'Min. Year Built',
      field: 'min_year_built',
      text: filterValue,
      value: searchParams.min_year_built
    });
  }

  if(searchParams.min_roi){
    let minLabel = searchParams.min_roi;
    let filterValue = `> ${minLabel}% ROI`;
    activeFilters.push({
      displayName: 'Min. ROI',
      field: 'min_roi',
      text: filterValue,
      value: searchParams.min_roi
    });
  }

  if(searchParams.max_roi){
    let maxLabel = searchParams.max_roi;
    let filterValue = `< ${maxLabel}% ROI`;
    activeFilters.push({
      displayName: 'Max. ROI',
      field: 'max_roi',
      text: filterValue,
      value: searchParams.max_roi
    });
  }

  if(searchParams.min_net_yield){
    let minLabel = searchParams.min_net_yield;
    let filterValue = `> ${minLabel}% NY`;
    activeFilters.push({
      displayName: 'Min. Net Yield',
      field: 'min_net_yield',
      text: filterValue,
      value: searchParams.min_net_yield
    });
  }

  if(searchParams.max_net_yield){
    let maxLabel = searchParams.max_net_yield;
    let filterValue = `< ${maxLabel}% NY`;
    activeFilters.push({
      displayName: 'Max. Net Yield',
      field: 'max_net_yield',
      text: filterValue,
      value: searchParams.max_net_yield
    });
  }

  if(searchParams.min_gross_yield){
    let minLabel = searchParams.min_gross_yield;
    let filterValue = `> ${minLabel}% GY`;
    activeFilters.push({
      displayName: 'Min. Gross Yield',
      field: 'min_gross_yield',
      text: filterValue,
      value: searchParams.min_gross_yield
    });
  }

  if(searchParams.max_gross_yield){
    let maxLabel = searchParams.max_gross_yield;
    let filterValue = `< ${maxLabel}% GY`;
    activeFilters.push({
      displayName: 'Max. Gross Yield',
      field: 'max_gross_yield',
      text: filterValue,
      value: searchParams.max_gross_yield
    });
  }

  if(searchParams.min_expense_load){
    let minLabel = searchParams.min_expense_load;
    let filterValue = `> ${minLabel}% EL`;
    activeFilters.push({
      displayName: 'Min. Expense Load',
      field: 'min_expense_load',
      text: filterValue,
      value: searchParams.min_expense_load
    });
  }

  if(searchParams.max_expense_load){
    let maxLabel = searchParams.max_expense_load;
    let filterValue = `< ${maxLabel}% EL`;
    activeFilters.push({
      displayName: 'Max. Expense Load',
      field: 'max_expense_load',
      text: filterValue,
      value: searchParams.max_expense_load
    });
  }

  if(searchParams.min_hpa){
    let minLabel = searchParams.min_hpa;
    let filterValue = `> ${minLabel}% HPA`;
    activeFilters.push({
      displayName: 'Min. Home Price Appreciation',
      field: 'min_hpa',
      text: filterValue,
      value: searchParams.min_hpa
    });
  }

  if(searchParams.max_hpa){
    let maxLabel = searchParams.max_hpa;
    let filterValue = `< ${maxLabel}% HPA`;
    activeFilters.push({
      displayName: 'Max. Home Price Appreciation',
      field: 'max_hpa',
      text: filterValue,
      value: searchParams.max_hpa
    });
  }

  if(searchParams.min_monthly_rent){
    let minLabel = convertToThousandsLabel(searchParams.min_monthly_rent, 'for-rent');
    let filterValue = `> ${minLabel}`;
    activeFilters.push({
      displayName: 'Min. Monthly Rent',
      field: 'min_monthly_rent',
      text: filterValue,
      value: searchParams.min_monthly_rent
    });
  }

  if(searchParams.max_monthly_rent){
    let maxLabel = convertToThousandsLabel(searchParams.max_monthly_rent, 'for-rent');
    let filterValue = `< ${maxLabel}`;
    activeFilters.push({
      displayName: 'Max. Monthly Rent',
      field: 'max_monthly_rent',
      text: filterValue,
      value: searchParams.max_monthly_rent
    });
  }

  if(searchParams.min_sqft){
    let filterValue = `> ${searchParams.min_sqft} sqft.`;
    activeFilters.push({
      displayName: 'Minimum Square Feet',
      field: 'min_sqft',
      text: filterValue,
      value: searchParams.min_sqft
    });
  }

  if(searchParams.max_sqft){
    let filterValue = `< ${searchParams.max_sqft} sqft.`;
    activeFilters.push({
      displayName: 'Maximum Square Feet',
      field: 'max_sqft',
      text: filterValue,
      value: searchParams.max_sqft
    });
  }
  if(searchParams.min_lot_size){
    let filterValue = `> ${searchParams.min_lot_size} sqft.`;
    activeFilters.push({
      displayName: 'Minimum Lot Size (in square feet)',
      field: 'min_lot_size',
      text: filterValue,
      value: searchParams.min_lot_size
    });
  }

  if(searchParams.max_lot_size){
    let filterValue = `< ${searchParams.max_lot_size} sqft.`;
    activeFilters.push({
      displayName: 'Maximum Lot Size (in square feet)',
      field: 'max_lot_size',
      text: filterValue,
      value: searchParams.max_lot_size
    });
  }

  /* Interior */
  if(searchParams.has_dining_area){
    activeFilters.push({
      displayName: 'Dining Area', 
      field: 'has_dining_area'
    });
  }
  if(searchParams.has_high_ceilings){
    activeFilters.push({
      displayName: 'High Ceilings', 
      field: 'has_high_ceilings'
    });
  }
  if(searchParams.has_ceiling_fans){
    activeFilters.push({
      displayName: 'Ceiling Fans', 
      field: 'has_ceiling_fans'
    });
  }
  if(searchParams.has_walk_in_closets){
    activeFilters.push({
      displayName: 'Walk-in Closets', 
      field: 'has_walk_in_closets'
    });
  }
  if(searchParams.has_granite_countertops){
    activeFilters.push({
      displayName: 'Granite Countertops', 
      field: 'has_granite_countertops'
    });
  }
  if(searchParams.has_satellite_tv){
    activeFilters.push({
      displayName: 'Satellite TV', 
      field: 'has_satellite_tv'
    });
  }
  if(searchParams.has_cable_ready){
    activeFilters.push({
      displayName: 'Cable-ready', 
      field: 'has_cable_ready'
    });
  }
  if(searchParams.has_fireplace){
    activeFilters.push({
      displayName: 'Fireplace', 
      field: 'has_fireplace'
    });
  }
  if(searchParams.has_storage){
    activeFilters.push({
      displayName: 'Storage', 
      field: 'has_storage'
    });
  }
  if(searchParams.has_indoor_jacuzzi){
    activeFilters.push({
      displayName: 'Indoor Jacuzzi', 
      field: 'has_indoor_jacuzzi'
    });
  }

  /* Flooring */
  if(searchParams.has_ceramic_tile){
    activeFilters.push({
      displayName: 'Ceramic Tile',
      field: 'has_ceramic_tile',
    });
  }
  if(searchParams.has_hardwood_floors){
    activeFilters.push({
      displayName: 'Hardwood Floors',
      field: 'has_hardwood_floors',
    });
  }
  if(searchParams.has_new_carpet){
    activeFilters.push({
      displayName: 'New Carpet',
      field: 'has_new_carpet',
    });
  }

  /* Kitchen */
  if(searchParams.has_stainless_steel_appliances){
    activeFilters.push({
      displayName: 'Stainless Steel Appliances',
      field: 'has_stainless_steel_appliances',
    });
  }
  if(searchParams.has_eat_in_kitchen){
    activeFilters.push({
      displayName: 'Eat-in Kitchen',
      field: 'has_eat_in_kitchen',
    });
  }
  if(searchParams.has_oven_range){
    activeFilters.push({
      displayName: 'Oven/Range',
      field: 'has_oven_range',
    });
  }
  if(searchParams.has_garbage_disposal){
    activeFilters.push({
      displayName: 'Garbage Disposal',
      field: 'has_garbage_disposal',
    });
  }
  if(searchParams.has_refrigerator){
    activeFilters.push({
      displayName: 'Refrigerator',
      field: 'has_refrigerator',
    });
  }
  if(searchParams.has_stove){
    activeFilters.push({
      displayName: 'Stove',
      field: 'has_stove',
    });
  }
  if(searchParams.has_dishwasher){
    activeFilters.push({
      displayName: 'Dishwasher',
      field: 'has_dishwasher',
    });
  }
  if(searchParams.has_microwave){
    activeFilters.push({
      displayName: 'Microwave',
      field: 'has_microwave',
    });
  }

  // Laundry
  if(searchParams.has_washer){
    activeFilters.push({
      displayName: 'Washer',
      field: 'has_washer',
    });
  }
  if(searchParams.has_dryer){
    activeFilters.push({
      displayName: 'Dryer',
      field: 'has_dryer',
    });
  }

  // Heating & Cooling
  if(searchParams.has_ac){
    activeFilters.push({
      displayName: 'Air Conditioning',
      field: 'has_ac',
    });
  }
  if(searchParams.has_central_heating){
    activeFilters.push({
      displayName: 'Central Heating',
      field: 'has_central_heating',
    });
  }

  // Other

  // if(searchParams.leased_properties_only){
  //   activeFilters.push({
  //     displayName: 'Leased Properties Only',
  //     field: 'leased_properties_only'
  //   });
  // }
  if(searchParams.section8){
    activeFilters.push({
      displayName: 'Section 8',
      field: 'section8'
    });
  }
  if(searchParams.has_views){
    activeFilters.push({
      displayName: 'Views',
      field: 'has_views'
    });
  }


  if(Array.isArray(searchParams.selected_zipcodes) && searchParams.selected_zipcodes.length > 0){
    searchParams.selected_zipcodes.map(zipcode => {
      activeFilters.push({
        displayName: zipcode,
        field: 'zipcode_' + zipcode
      });
    });
  }
    
    
  return activeFilters;
};

export const infoWindowPosition = state => {
  if(!state.highlightedProperty.lat) return {};
  return {
    lat: parseFloat(state.highlightedProperty.lat),
    lng: parseFloat(state.highlightedProperty.lng)
  };
};